import "./IntroProdutosDestaque.css";
import { useNavigate } from "react-router-dom";
import { useMemo, useRef, useEffect } from "react";
import { verificaAdmin } from "../../../../components/utils/verificaAdmin";
import AdminProdutosDestaque from "./AdminProdutosDestaque/AdminProdutosDestaque";
import VerificaToken from "../../../../components/utils/VerificaToken";
import { useState } from "react";

function IntroProdutosDestaque({
  produtosDestaque,
  loading,
  localizacao,
  atualizarProdutosDestaque
}) {
  console.log(produtosDestaque)
  const navigate = useNavigate();
  const containerRef = useRef(null);
  const isAdmin = verificaAdmin();
  const [usuario, setUsuario] = useState({
    login: false,
    tipo: "",
  });

  const [podeEsquerda, setPodeEsquerda] = useState(false);
  const [podeDireita, setPodeDireita] = useState(false);

  const atualizarBotoes = () => {
    const el = containerRef.current;
    if (!el) return;

    setPodeEsquerda(el.scrollLeft > 0);

    setPodeDireita(
      el.scrollLeft + el.clientWidth < el.scrollWidth - 2
    );
  };


  //  console.log("produtos", produtosDestaque)
  const [abrirAdmin, setAbrirAdmin] =
    useState(false);


  useEffect(() => {
    async function verificar() {
      const dados = await VerificaToken();
      setUsuario(dados);
    }

    verificar();
  }, []);

  // const mostrarPrecos = usuario.login;
  const ehCNPJ = usuario.login && usuario.tipo === "CNPJ";

  const produtosIntro = useMemo(() => {
    if (!Array.isArray(produtosDestaque)) return [];

    const localizacaoNumero = Number(localizacao);

    const hoje = new Date().toISOString().split("T")[0];

    return produtosDestaque.filter(produto => {
      const dataValidade = produto.data_validade?.split("T")[0];

      return (
        Number(produto.site) === 1 &&
        Number(produto.site_posi) === localizacaoNumero &&
        dataValidade >= hoje
      );
    });
  }, [produtosDestaque, localizacao]);

  //console.log("localizacao", localizacao);

  useEffect(() => {
    atualizarBotoes();

    const el = containerRef.current;
    if (!el) return;

    el.addEventListener("scroll", atualizarBotoes);
    window.addEventListener("resize", atualizarBotoes);

    return () => {
      el.removeEventListener("scroll", atualizarBotoes);
      window.removeEventListener("resize", atualizarBotoes);
    };
  }, [produtosIntro]);

  const SCROLL_STEP = 500;

  const scrollLeft = () => {
    containerRef.current?.scrollBy({
      left: -SCROLL_STEP,
      behavior: "smooth",
    });
  };

  const scrollRight = () => {
    containerRef.current?.scrollBy({
      left: SCROLL_STEP,
      behavior: "smooth",
    });
  };

  if (loading) {
    return (
      <>
        <p className="intro-part3-status">
          Carregando produtos...
        </p>

      </>
    );
  }

  if (produtosIntro.length === 0) {
    return (
      <section className="intro">
        <div>
          {isAdmin && (
            <div className="intro-part3-empty">
              <div>Produtos Destaque {localizacao}</div>
            </div>
          )}
        </div>
        {isAdmin && (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "10px"
            }}
          >

            <button
              className="btn-editar-categorias"
              onClick={() => setAbrirAdmin(true)}
            >
              Editar
            </button>


          </div>
        )}

        {abrirAdmin && (
          <div
            className="admin-modal-overlay"
            onClick={() => setAbrirAdmin(false)}
          >
            <div
              className="admin-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <AdminProdutosDestaque
                produtosDestaque={produtosDestaque}
                localizacao={localizacao}
                onClose={() => setAbrirAdmin(false)}
                onAtualizar={atualizarProdutosDestaque}
              />
            </div>
          </div>
        )}

      </section>
    );
  }

  return (
    <section className="intro-part3-wrapper">

      {isAdmin && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "10px"
          }}
        >
          <button
            className="btn-editar-categorias"
            onClick={() => setAbrirAdmin(true)}
          >
            Editar
          </button>
        </div>
      )}
      {podeEsquerda && (
        <button
          className="scroll-btn-itens left"
          onClick={scrollLeft}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
      )}

      <div className="intro-part3-container">
        <div
          className="intro-part3-products"
          ref={containerRef}
        >
          {produtosIntro.map(produto => (
            <div
              className="product-card"
              key={produto.id}
              onClick={() =>
                navigate(`/cardproduto/${produto.produto_id}`)
              }
            >
              {produto.foto ? (
                <img
                  src={produto.foto}
                  alt={produto.descricao}
                />
              ) : (
                <div className="produto-sem-imagem">
                  IMG
                </div>
              )}

              <h3>
                {produto.descricao?.length > 46
                  ? `${produto.descricao.slice(0, 46).trim().replace(/\s+\S*$/, "")}...`
                  : produto.descricao}
              </h3>

              {(() => {
                const pesoCaixa = produto.correspondencias?.find(
                  (c) => Number(c.Unidade) === 2
                );

                const pesoUnidade = produto.correspondencias?.find(
                  (c) => Number(c.Unidade) === 1
                );

                return (
                  <div className="produto-pesos-destaque">
                    {pesoCaixa && (
                      <div>
                        CX: {Number(pesoCaixa.corresp).toLocaleString("pt-BR")}kg
                      </div>
                    )}

                    {pesoCaixa && pesoUnidade && (
                      <div className="produto-peso-separador">•</div>
                    )}

                    {pesoUnidade && (
                      <div>
                        Unid.: {Number(pesoUnidade.corresp).toLocaleString("pt-BR")}kg
                      </div>
                    )}
                  </div>
                );
              })()}

              <div className="produto-precos">
                {!usuario.login ? (
                  <strong className="preco-desconto-semlog">
                    <strong>R$ </strong>
                    <div className="preco-borrado-semlog">
                      {Number(produto.precovenda).toFixed(2)}
                    </div>
                  </strong>
                ) : ehCNPJ ? (
                  <>
                    <div className="preco-antigo">
                      R$ {Number(produto.precovenda).toFixed(2)}
                    </div>

                    <strong className="preco-desconto">
                      R$ {Number(produto.valor_unit).toFixed(2)}
                    </strong>
                  </>
                ) : (
                  <strong className="preco-desconto">
                    R$ {Number(produto.precovenda).toFixed(2)}
                  </strong>
                )}
              </div>

              <button>Ver Produto</button>
            </div>
          ))}
        </div>
      </div>

      {podeDireita && (
        <button
          className="scroll-btn-itens right"
          onClick={scrollRight}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>
      )}

      {abrirAdmin && (
        <div
          className="admin-modal-overlay"
          onClick={() => setAbrirAdmin(false)}
        >
          <div
            className="admin-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <AdminProdutosDestaque
              produtosDestaque={produtosDestaque}
              localizacao={localizacao}
              onClose={() => setAbrirAdmin(false)}
              onAtualizar={atualizarProdutosDestaque}
            />
          </div>
        </div>
      )}

    </section>
  );
}

export default IntroProdutosDestaque;
